// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__rag_fd845a', '__rag_Fallback_fd845a'"},"className":"__className_fd845a","variable":"__variable_fd845a"};